<template>
  <form @click.prevent="emitValues()" ref="form">
    <div class="row">
      <div class="col-md-6 col-xs-12">
        <div class="select">
          <select class="select-text" @change="onChangeNationality($event)" @blur="$v.formValues.nationalityId.$touch()"
            :class="{ invalid: $v.formValues.nationalityId.$error }" v-model="formValues.nationalityId">

            <option v-for="item in nationalityItems" :value="item.key" :key="item.key">
              {{ item.value }}
            </option>
          </select>
          <p class="text-danger" v-if="
            !$v.formValues.nationalityId.required &&
            $v.formValues.nationalityId.$dirty
          ">
            {{ $t("SearchResults.PleaseSelectCountry") }}
          </p>
          <span class="select-highlight"></span>
          <span class="select-bar"></span>
          <label class="select-label"><span class="required_star">*</span> {{ $t("Country") }}</label>

        </div>
      </div>


      <div class="col-md-6 col-xs-12">
        
        <div class="group_mdi">
          <input v-model.trim="formValues.nationalCode"  @blur="$v.formValues.nationalCode.$touch()" :class="{
            invalid:
              $v.formValues.nationalCode.$error || !onIsDuplicatedPassenger,
          }" />
          <span class="highlight"></span>
          <span class="bar"></span>
<!-- 
          <p class="text-danger" v-if="
            !$v.formValues.nationalCode.$error &&
            $v.formValues.nationalCode.$dirty
          ">
            لطفا کدملی/شماره پاسپورت را وارد کنید
          </p> -->
          <p class="text-danger" v-if="!onIsDuplicatedPassenger">
            {{ $t("SearchResults.NationalCodeRepetitive") }}
          </p>
          <label class="lbl-report">{{ $t("NationalCode") }}/{{ $t("Passport") }}</label>
        </div>
      </div>
      <div v-if="showFaName" class="col-md-6 col-xs-12">
        <div class="group_mdi">

          <input v-model.trim="formValues.persianName" @blur="$v.formValues.persianName.$touch()"
            :class="{ invalid: $v.formValues.persianName.$error }" @keypress="isPersianLetter($event)" />
          <span class="highlight"></span>
          <span class="bar"></span>
          <p class="text-danger" v-if="
            $v.formValues.persianName.$error &&
            $v.formValues.persianName.$dirty
          ">
            {{ $t("SearchResults.PleaseEnterPersianName") }}
          </p>
          <label class="lbl-report"><span class="required_star">*</span>{{ $t("Name") }}</label>
        </div>
      </div>
      <div v-if="showFaName" class="col-md-6 col-xs-12">
        <div class="group_mdi">

          <input v-model.trim="formValues.persianFamily" @blur="$v.formValues.persianFamily.$touch()"
            :class="{ invalid: $v.formValues.persianFamily.$error }" @keypress="isPersianLetter($event)" />
          <span class="highlight"></span>
          <span class="bar"></span>
          <p class="text-danger" v-if="
            $v.formValues.persianFamily.$error &&
            $v.formValues.persianFamily.$dirty
          ">
          {{ $t("SearchResults.PleaseEnterPersianLastName") }}
          </p>
          <label class="lbl-report"><span class="required_star">*</span>{{ $t("LName") }}</label>
        </div>
      </div>
    </div>


    <div v-if="showEnName" class="col-md-6 col-xs-12">
      <div class="group_mdi">
        <input v-model.trim="formValues.englishName" @blur="$v.formValues.englishName.$touch()"
          :class="{ invalid: $v.formValues.englishName.$error }" @keypress="isLatinLetter($event)"
          style="text-transform: uppercase" />
        <span class="highlight"></span>
        <span class="bar"></span>
        <p class="text-danger" v-if="
          $v.formValues.englishName.$error &&
          $v.formValues.englishName.$dirty
        ">
        {{ $t("SearchResults.PleaseEnterEnglishName") }}
          
        </p>
        <label class="lbl-report"><span class="required_star">*</span>{{ $t("EName") }}</label>
      </div>
    </div>
    <div v-if="showEnName" class="col-md-6 col-xs-12">
      <div class="group_mdi">

        <input @keypress="isLatinLetter($event)" v-model.trim="formValues.englishFamily"
          @blur="$v.formValues.englishFamily.$touch()" :class="{ invalid: $v.formValues.englishFamily.$error }"
          style="text-transform: uppercase" />
        <span class="highlight"></span>
        <span class="bar"></span>
        <p class="text-danger" v-if="
          !$v.formValues.englishFamily.required &&
          $v.formValues.englishFamily.$dirty
        ">{{ $t("PleaseEnterEnglishLastName") }}
        </p>
        <label class="lbl-report"><span class="required_star">*</span>{{ $t("ELastName") }}</label>
      </div>
    </div>


    <div class="row">
      <div class="col-md-6 col-xs-12">
        <div class="select">
          <select class="select-text" required @blur="$v.formValues.genderId.$touch()"
            :class="{ invalid: $v.formValues.genderId.$error }" v-model="formValues.genderId">
            <option v-for="item in genderItems" :value="item.key" :key="item.key">
              {{ item.value }}
            </option>
          </select>

          <span class="select-highlight"></span>
          <span class="select-bar"></span>
          <p class="text-danger" v-if="
            !$v.formValues.genderId.required &&
            $v.formValues.nationalityId.$dirty
          ">
            {{ $t("PleaseChooseSex") }}
          </p>
          <label class="select-label"><span class="required_star">*</span> {{ $t("Sex") }}</label>

        </div>
        <!-- <div class="form-group">
          <label><span class="required_star">*</span>جنسیت</label>
          <div class="styled-select select">
            <select style="width: 100%; height: 36px; border-color: #ced4da" required
              @blur="$v.formValues.genderId.$touch()" :class="{ invalid: $v.formValues.genderId.$error }"
              v-model="formValues.genderId">
              <option v-for="item in genderItems" :value="item.key" :key="item.key">
                {{ item.value }}
              </option>
            </select>
            <span class="highlight"></span>
            <span class="bar"></span>
            <p class="text-danger" v-if="
              !$v.formValues.genderId.required &&
              $v.formValues.nationalityId.$dirty
            ">
              لطفا جنسیت را انتخاب نمائید
            </p>
          </div>
        </div> -->
      </div>
      <div class="col-md-6 col-xs-12">
        <div class="form-group">
          <label>   {{ $t("BirthDate") }}</label>

          <date-picker readonly auto-submit :min="minDate" :max="maxDate" format="jYYYY/jMM/jDD"
            display-format="jYYYY/jMM/jDD" v-model="formValues.birthDate" color="#00C3E1" popover="bottom-right"
            :class="{ invalid: $v.formValues.birthDate.$error }" :column="1" mode="single">
          </date-picker>

          <!-- <input type="text" class="form-control form-control-lg" v-model="formValues.birthDate" :id="onFormId"
            @blur="$v.formValues.birthDate.$touch()" :class="{ invalid: $v.formValues.birthDate.$error }" />

          <date-picker color="#4e77da" auto-submit locale="fa,en" popover format="jYYYY/jM/jD"
            v-model="formValues.birthDate" :element="onFormId" /> -->

          <!-- <input
                type="text"
                
                v-datepicker
                v-model="formValues.birthDate"
            @blur="$v.formValues.birthDate.$touch()"
            :class="{invalid:$v.formValues.birthDate.$error}"
              />-->

          <p class="text-danger" v-if="!$v.formValues.birthDate.required && $v.formValues.birthDate.$dirty">
          {{ $t("PleaseEnterCorrectBirthDate") }}
          </p>
        </div>
      </div>
    </div>

    <div class="row">
      <div v-if="onIsMainGuest" class="col-md-6 col-xs-12">
        <div class="group_mdi">

          <input v-model.trim="formValues.mobilePhone" @blur="$v.formValues.mobilePhone.$touch()"
            :class="{ invalid: $v.formValues.mobilePhone.$error }" />
          <!-- <p
            class="text-danger"
            v-if="
              !$v.formValues.mobilePhone.required &&
              $v.formValues.mobilePhone.$dirty
            "
          >
            لطفا شماره موبایل را وارد کنید
          </p> -->
          <span class="highlight"></span>
          <span class="bar"></span>
          <p class="text-danger" v-if="
            $v.formValues.mobilePhone.$error &&
            $v.formValues.mobilePhone.$dirty
          ">
            {{ $t("PleaseEnterMobileCorrectly") }}
          </p>
          <label class="lbl-report"><span class="required_star">*</span> {{ $t("MobileNumber") }}</label>
        </div>
      </div>

      <div v-if="onIsMainGuest" class="col-md-6 col-xs-12">
        <div class="group_mdi">

          <input v-model.trim="formValues.email" @blur="$v.formValues.email.$touch()"
            :class="{ invalid: $v.formValues.email.$error }" />
          <span class="highlight"></span>
          <span class="bar"></span>
          <p class="text-danger" v-if="!$v.formValues.email.required && $v.formValues.email.$dirty">
             {{ $t("PleaseEnterEmail") }}
            
          </p>
          <p class="text-danger" v-if="!$v.formValues.email.email && $v.formValues.email.$dirty">
              {{ $t("EmailNotValid") }}
          </p>
          <label class="lbl-report"><span class="required_star">*</span>{{ $t("Email") }}</label>
        </div>
      </div>
    </div>
  </form>
</template>
<script>
import { required, minLength, email } from "vuelidate/lib/validators";

import momentjalaali from "moment-jalaali";
// import datePicker, { PersianDate } from "@alireza-ab/vue-persian-datepicker";
import dateUtil from "../../utils/date";
import moment from "moment";



export default {
  props: {
    entriedForm: {
      type: Object,
    },
    checkValid: {
      type: Boolean,
    },
    formId: {
      type: Number,
    },
    isMainGuest: {
      type: Boolean,
    },
    duplicatedNationalCode: {
      type: Boolean,
      default: false,
    },
    ageType: {
      type: String,
      default: "",
    },
  },
  components: {

  },
  data: () => ({
    showEnName: false,
    showFaName: true,
    params: {},
    minDate: "1400/02/01",
    maxDate: "1400/03/01",
    formValues: {
      ageType: "",
      mobilePhone: "",
      email: "",
      persianName: "",
      persianFamily: "",
      englishName: "",
      englishFamily: "",
      genderId: "",
      nationalityId: "",
      nationalCode: "",
      birthDate: "",
    },
    nationalityItems: [
      { key: 1, value: "ایرانی" },
      { key: 2, value: "غیر ایرانی" },
    ],
    genderItems: [
      { key: 1, value: "مرد" },
      { key: 2, value: "زن" },
    ],
  }),
  validations() {
    if (this.onIsMainGuest) {
      if (this.formValues.nationalityId == 2) {
        return {
          formValues: {
            mobilePhone: {
              required, onCheckValid: (val) => {

                if (val === "") { return false }
                if (/^(\+98|0)?9\d{9}$/.test(val)) {
                  return true;
                } else {
                  return false;
                }
              }
            },
            email: { required, email },
            persianName: {},
            persianFamily: {},
            englishName: {
              checkIsLatin: (val) => {

                if (val === "") { return false }
                if (/^[A-Za-z\s]+$/.test(val)) {
                  return true;
                } else {
                  return false;
                }
              },
            },
            englishFamily: {
              checkIsLatin: (val) => {

                if (val === "") { return false }
                if (/^[A-Za-z\s]+$/.test(val)) {
                  return true;
                } else {
                  return false;
                }
              },
            },

            nationalityId: {
              required,
              checkEmpty: (val) => {
                if (val === "" || val === null) {
                  return false;
                } else {
                  return true;
                }
              },
            },
            genderId: { required },
            birthDate: {},
            nationalCode: {},
          },
        };
      } else {
        return {
          formValues: {
            mobilePhone: {
              required, onCheckValid: (val) => {

                if (val === "") { return false }
                if (/^(\+98|0)?9\d{9}$/.test(val)) {
                  return true;
                } else {
                  return false;
                }
              }
            },
            email: { required, email },
            persianName: {
              checkIsPersian: (val) => {

                if (val === "") { return false }
                if (/^[\u0600-\u06FF\s]+$/.test(val)) {
                  return true;
                } else {
                  return false;
                }
              }
            },
            persianFamily: {
              checkIsPersian: (val) => {

                if (val === "") { return false }
                if (/^[\u0600-\u06FF\s]+$/.test(val)) {
                  return true;
                } else {
                  return false;
                }
              }
            },
            englishName: {},
            englishFamily: {},
            nationalCode: {
              checkMelliCode: (meli_code) => {
                if (meli_code === "") {
                  return true;
                }
                if (
                  meli_code == "1111111111" ||
                  meli_code == "0000000000" ||
                  meli_code == "2222222222" ||
                  meli_code == "3333333333" ||
                  meli_code == "4444444444" ||
                  meli_code == "5555555555" ||
                  meli_code == "6666666666" ||
                  meli_code == "7777777777" ||
                  meli_code == "8888888888" ||
                  meli_code == "9999999999"
                ) {
                  return false;
                }
                var c = parseInt(meli_code.charAt(9));
                var n =
                  parseInt(meli_code.charAt(0)) * 10 +
                  parseInt(meli_code.charAt(1)) * 9 +
                  parseInt(meli_code.charAt(2)) * 8 +
                  parseInt(meli_code.charAt(3)) * 7 +
                  parseInt(meli_code.charAt(4)) * 6 +
                  parseInt(meli_code.charAt(5)) * 5 +
                  parseInt(meli_code.charAt(6)) * 4 +
                  parseInt(meli_code.charAt(7)) * 3 +
                  parseInt(meli_code.charAt(8)) * 2;
                var r = n - parseInt(n / 11) * 11;
                if (
                  (r == 0 && r == c) ||
                  (r == 1 && c == 1) ||
                  (r > 1 && c == 11 - r)
                ) {
                  return true;
                } else {
                  return false;
                }
              },
            },
            nationalityId: {
              required,
              checkEmpty: (val) => {
                if (val === "" || val === null) {
                  return false;
                } else {
                  return true;
                }
              },
            },
            genderId: { required },
            birthDate: {},
          },
        };
      }
    } else {
      if (this.formValues.nationalityId == 2) {
        return {
          formValues: {
            mobilePhone: {},
            email: {},
            persianName: {},
            persianFamily: {},
            englishName: {
              checkIsLatin: (val) => {

                if (val === "") { return false }
                if (/^[A-Za-z\s]+$/.test(val)) {
                  return true;
                } else {
                  return false;
                }
              },
            },
            englishFamily: {
              checkIsLatin: (val) => {

                if (val === "") { return false }
                if (/^[A-Za-z\s]+$/.test(val)) {
                  return true;
                } else {
                  return false;
                }
              },
            },

            nationalityId: {
              required,
              checkEmpty: (val) => {
                if (val === "" || val === null) {
                  return false;
                } else {
                  return true;
                }
              },
            },
            genderId: { required },
            birthDate: {},
            nationalCode: {},
          },
        };
      } else {
        return {
          formValues: {
            mobilePhone: {},
            email: {},
            persianName: {
              checkIsPersian: (val) => {

                if (val === "") { return false }
                if (/^[\u0600-\u06FF\s]+$/.test(val)) {
                  return true;
                } else {
                  return false;
                }
              }
            },
            persianFamily: {
              checkIsPersian: (val) => {

                if (val === "") { return false }
                if (/^[\u0600-\u06FF\s]+$/.test(val)) {
                  return true;
                } else {
                  return false;
                }
              }
            },
            englishName: {},
            englishFamily: {},
            nationalCode: {
              checkMelliCode: (meli_code) => {
                if (meli_code === "") {
                  return true;
                }
                if (
                  meli_code == "1111111111" ||
                  meli_code == "0000000000" ||
                  meli_code == "2222222222" ||
                  meli_code == "3333333333" ||
                  meli_code == "4444444444" ||
                  meli_code == "5555555555" ||
                  meli_code == "6666666666" ||
                  meli_code == "7777777777" ||
                  meli_code == "8888888888" ||
                  meli_code == "9999999999"
                ) {
                  return false;
                }
                var c = parseInt(meli_code.charAt(9));
                var n =
                  parseInt(meli_code.charAt(0)) * 10 +
                  parseInt(meli_code.charAt(1)) * 9 +
                  parseInt(meli_code.charAt(2)) * 8 +
                  parseInt(meli_code.charAt(3)) * 7 +
                  parseInt(meli_code.charAt(4)) * 6 +
                  parseInt(meli_code.charAt(5)) * 5 +
                  parseInt(meli_code.charAt(6)) * 4 +
                  parseInt(meli_code.charAt(7)) * 3 +
                  parseInt(meli_code.charAt(8)) * 2;
                var r = n - parseInt(n / 11) * 11;
                if (
                  (r == 0 && r == c) ||
                  (r == 1 && c == 1) ||
                  (r > 1 && c == 11 - r)
                ) {
                  return true;
                } else {
                  return false;
                }
              },
            },
            nationalityId: {
              required,
              checkEmpty: (val) => {
                if (val === "" || val === null) {
                  return false;
                } else {
                  return true;
                }
              },
            },
            genderId: { required },
            birthDate: {},
          },
        };
      }
    }
  },
  watch: {
    duplicatedNationalCode: function (val) {
      if (val === true) {
        this.$v.$touch();
        this.$v.$invalid = true;
      } else {
        this.$v.$invalid = false;
      }
    },
    checkValid: function (val) {

      // if (val === true) {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        this.$emit("isValid", true);
      } else {
        this.$emit("isValid", false);
      }
      // } else {
      //   this.$emit("isValid", null);
      // }
    },
  },
  computed: {
    onIsMainGuest() {
      return (this.isMainGuest = this.isMainGuest);
    },
    onFormId() {
      return (this.formId = this.formId);
    },
    onEntriedForm() {
      return (this.entriedForm = this.entriedForm);
    },
    onIsDuplicatedPassenger() {
      return (this.duplicatedNationalCode = this.duplicatedNationalCode);
    },
  },
  created() {

    this.params = this.$route.query;
    var toDate = dateUtil.ConvertToPersian(this.params.endDate);

    var currentDate = momentjalaali().format("jYYYY/jMM/jDD");
    var dateShamsi = momentjalaali(currentDate, "jYYYY/jMM/jDD");

    let fDate = momentjalaali(currentDate, "jYYYY/jMM/jDD").format(
      "YYYY/MM/DD"
    );
    var tDate = this.params.endDate;
    var diff = 0;
    if (toDate !== "" && toDate !== null) {
      var startDate = moment(fDate);
      var endDate = moment(tDate);
      let duration = moment.duration(endDate.diff(startDate));

      diff = Math.round(duration.asDays());

    }
// debugger
    if (this.ageType === "ADL") {
      this.minDate = momentjalaali(currentDate, "jYYYY/jMM/jDD")
        .add(-160, "jYear")
        .format("jYYYY/jMM/jDD");
      this.maxDate = momentjalaali(currentDate, "jYYYY/jMM/jDD")
        .add(-12, "jYear")
        .add(-diff, "day")
        .format("jYYYY/jMM/jDD");
    } else if (this.ageType === "CHL") {
      this.minDate = momentjalaali(currentDate, "jYYYY/jMM/jDD")
        .add(-12, "jYear")
        .add(diff, "day")
        .format("jYYYY/jMM/jDD");
      this.maxDate = momentjalaali(currentDate, "jYYYY/jMM/jDD")
        .add(-2, "jYear")
        .add(-diff, "day")
        .format("jYYYY/jMM/jDD");
    } else if (this.ageType === "INF") {
      this.minDate = momentjalaali(currentDate, "jYYYY/jMM/jDD")
        .add(-2, "jYear")
        .add(diff, "day")
        .format("jYYYY/jMM/jDD");
      this.maxDate = dateShamsi.format("jYYYY/jMM/jDD");
    }

    var bthd = "";
    if (this.entriedForm.birthDate !== "") {
      bthd = momentjalaali(this.entriedForm.birthDate, "jYYYY/jMM/jDD").format(
        "YYYY/MM/DD"
      );
    }

    this.formValues = {
      ageType: this.ageType,
      mobilePhone: this.entriedForm.mobilePhone,
      email: this.entriedForm.email,
      persianName: this.entriedForm.persianName,
      persianFamily: this.entriedForm.persianFamily,
      englishName: this.entriedForm.englishName,
      englishFamily: this.entriedForm.englishFamily,
      genderId: this.entriedForm.genderId,
      nationalityId: this.entriedForm.nationalityId,
      nationalCode: this.entriedForm.nationalCode,
      birthDate: bthd,
    };

    if (this.formValues.nationalityId === "") {
      this.formValues.nationalityId = 1;
    } else if (this.formValues.nationalityId === 1) {
      this.showFaName = true;
      this.showEnName = false;
    } else if (this.formValues.nationalityId === 2) {
      this.showEnName = true;
      this.showFaName = false;

    }

    // this.formValues = this.entriedForm;
  },
  methods: {
    onChangeNationality(event) {
      var value = event.target.value;
      if (value === "2") {
        this.showEnName = true;
        this.showFaName = false;

        this.formValues.englishName = "";
        this.formValues.englishFamily = "";
      } else if (value === "1") {
        this.formValues.persianName = "";
        this.formValues.persianFamily = "";
        this.showEnName = false;
        this.showFaName = true;
      }
    },
    selectBirthDate(date) {
      let p = new PersianDate();

      this.formValues.birthDate = p
        .parse(date.d.year, date.d.month, date.d.date)
        .toString();
    },
    isLatinLetter(e) {
      let char = String.fromCharCode(e.keyCode);
      if (/^[A-Za-z\s]+$/.test(char)) return true;
      else e.preventDefault();
    },
    isPersianLetter(e) {
      let char = String.fromCharCode(e.keyCode);
      if (/^[\u0600-\u06FF\s]+$/.test(char)) return true;
      else e.preventDefault();
    },
    emitValues() {
      if (this.formValues.nationalityId == 2) {
        this.formValues.persianName = this.formValues.englishName;
        this.formValues.persianFamily = this.formValues.englishFamily;
      } else if (this.formValues.nationalityId === 1) {
        this.formValues.englishName = this.formValues.persianName;
        this.formValues.englishFamily = this.formValues.persianFamily;
      }
      this.$emit("values", this.formValues);
    },
    convertDate(date) {
      if (momentjalaali(date, "jYYYY/jMM/jDD").isValid())
        return momentjalaali(date, "jYYYY/jMM/jDD").format("YYYY/MM/DD");
    },
  },
};
</script>
<style >
.styled-select {
  background-color: #fff !important;
  border: 1px solid #ced4da;
}

.pdp .pdp-group .pdp-icon {
  padding: 0.375rem 0.75rem;
  line-height: 1.5 !important;
  font-size: 14px !important;
  color: #495057;
  color: var(--text-color);
  background: #e9ecef;
  background: var(--icon-background);
  border: 1px solid #ced4da;
  border: 1px solid var(--border-color);
  display: none !important;
}

.pdp .pdp-group .pdp-input {
  display: block;
  height: calc(1.5em + 0.75rem + 2px);
  padding: 0.375rem 0.75rem;
  font-size: 14px !important;
  font-weight: 400;
  line-height: 1.5;
  background-clip: padding-box;
  border: 1px solid #ced4da;
  border: 1px solid var(--border-color);
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  position: relative;
  flex: 1 1 auto;
}

.required_star {
  color: #fe4343;
  font-size: 16px;
}
</style>